module.exports = __webpack_public_path__ + "static/media/fondoLogin.b4047788.jpg";